module.exports = __webpack_public_path__ + "static/media/institute-4-min.9ef0ff3f.webp";